import type {FC, InputHTMLAttributes} from 'react'

interface Props {
  head?: string
  content?: string
}

const ListText: FC<Props & InputHTMLAttributes<HTMLInputElement>> = ({
  head,
  content,
  ...props
}) => {
  return (
    <div className='row mb-7'>
     <label className='col-lg-4 fw-bold '>{head}</label>
     <div className='col-lg-8 fv-row'>
       <span className='fw-bold fs-6'>{content}</span>
     </div>
    </div>
  )
}

export default ListText
